import React from 'react'
import { Container } from 'react-bootstrap'
import AdasReportDetail from '../components/presentations/adasReportDetail'
import { useBreakpoint } from '../hooks'
import Layout from '../layout'

const VehicleReportDetailContainer = () => {
  const { BREAKPOINT, screenBiggerThan } = useBreakpoint()
  const isBiggerThanXL = screenBiggerThan(BREAKPOINT.XL)

  return (
    <Layout>
      <Container fluid={!isBiggerThanXL}>
        <AdasReportDetail />
      </Container>
    </Layout>
  )
}

export default VehicleReportDetailContainer
